module.exports = __webpack_public_path__ + "static/media/sidebar-index.2455593b.svg";